"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("@osmosys/models");
exports.getBlockDisplayName = (block) => {
    return block.name
        ? block.name
        : block.type === 'field' && block.fieldType
            ? `${models_1.FIELD_TYPES_MAP[block.fieldType]} block`
            : `Unnamed ${block.type} block`;
};
//# sourceMappingURL=getBlockDisplayName.js.map